import React, { createContext } from 'react';
import { SubscriptionFeatureKey as SubscriptionFeatureKeyGraphQL, useSubscriptionFeaturesAvailabilityByKeysQuery } from './graphql/api-platform-graphql';
export const SubscriptionFeaturesContext = /*#__PURE__*/createContext({
  subscriptionFeatures: new Map(),
  isLoading: false
});
export const SubscriptionFeatureKey = SubscriptionFeatureKeyGraphQL;
export const SubscriptionFeaturesProvider = ({
  features,
  children
}) => {
  const parentContext = React.useContext(SubscriptionFeaturesContext);
  const featuresToFetch = features.filter(feature => !parentContext.subscriptionFeatures.has(feature));
  const {
    isLoading,
    data
  } = useSubscriptionFeaturesAvailabilityByKeysQuery({
    keys: featuresToFetch
  });
  const subscriptionFeatures = new Map();
  for (const availability of (_data$subscriptionFea = data === null || data === void 0 ? void 0 : data.subscriptionFeaturesAvailabilityByKeys) !== null && _data$subscriptionFea !== void 0 ? _data$subscriptionFea : []) {
    var _data$subscriptionFea;
    subscriptionFeatures.set(availability.key, availability.isAvailable);
  }

  // Merge with any possible parents
  for (const key of parentContext.subscriptionFeatures.keys()) {
    subscriptionFeatures.set(key, parentContext.subscriptionFeatures.get(key));
  }

  // Define context value
  const providerContext = {
    subscriptionFeatures: subscriptionFeatures,
    isLoading: isLoading || parentContext.isLoading
  };

  // Return provider
  return /*#__PURE__*/React.createElement(SubscriptionFeaturesContext.Provider, {
    value: providerContext
  }, children);
};
//# sourceMappingURL=subscription-features-provider.js.map